<template>
  <section id="build-service" class="hero" :class="heroLayoutStylingClass">
    <video class="hero_bg" :src="buildBgMovie" :poster="buildBgImage" webkit-playsinline playsinline muted autoplay loop></video>
    <SectionContainer class="hero_container">
      <img class="hero_logo" :src="buildServiceLogo" alt="build service" role="heading" aria-level="1">
      <div class="hero_body">
        <h2 class="hero_title">情熱を未来に実装する</h2>
        <p class="hero_paragraph">
          <template v-for="(text, index) in paragraph.top">
            {{ text }}<br class="isOnlyPc" :key="index">
          </template>
        </p>
        <p class="hero_paragraph">
          <template v-for="(text, index) in paragraph.middle">
            {{ text }}<br class="isOnlyPc" :key="index">
          </template>
        </p>
        <p class="hero_paragraph">
          <template v-for="(text, index) in paragraph.bottom">
            {{ text }}<br class="isOnlyPc" :key="index">
          </template>
        </p>
        <p>
        </p>
      </div>
    </SectionContainer>
  </section>
</template>

<script>
import buildServiceLogo from '../../assets/images/build_servie_logo@2x.png'
import SectionContainer from '../atoms/SectionContainer'
import buildBgMovie from '../../assets/movies/bg_gradient.mp4'
import buildBgImage from '../../assets/images/gradation@2x.png'

export default {
  name: 'build-service',
  components: {
    SectionContainer
  },
  props: {
    visibleMovie: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      buildServiceLogo,
      paragraph: {
        top: [
          'ビジネス環境は凄まじいスピードで変化しています。',
          '企業は未来を見すえながら、ビジネスや組織をアップデートしつづける必要があります。',
          'しかし、そのための準備に時間をかける時代ではありません。',
          '変革の意志をいますぐ実行にうつすことが、緻密な計画よりも重要です。'
        ],
        middle: [
          'build serviceは変革を加速させます。',
          'buildのエンジニアやデザイナーが、変革を推進するチームに加わり、',
          '新しい事業やプロダクトの創造を支援。',
          '同時にアイデアを俊敏に形にする発想法と技法をチームにインストールします。',
          'ビジネスとテクノロジーを融合させるナレッジ。',
          'そして、確実な変化を手にしてください。',
          '実行するチームの熱は組織に伝播し、変革のエネルギーとなるでしょう。'
        ],
        bottom: [
          'わたしたちは確信しています。',
          '日本のいまを構築した企業がアップデートを果たすことで、',
          '誰も置き去りにしないデジタル社会が実現できる。',
          '人と自然が豊かに共生する美しい世界へとシフトできる。',
          'だからこそわたしたちは、変革を支援したい。',
          '尊いビジョンを掲げる企業の情熱を未来に実装したいのです。'
        ]
      },
      buildBgMovie,
      buildBgImage
    }
  },
  computed: {
    heroLayoutStylingClass () {
      return this.visibleMovie ? 'hero--large' : ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.hero {
  @include bpOnlyPc() {
    background-size: contain;
  }
  @include bpOnlySp() {
    background-size: cover;
  }
  background-repeat: no-repeat;
  background-position: left bottom;
  position: relative;
  &--large {
    @include bpOnlyPc() {
      padding-bottom: calc(600px / 2);
    }
    @include bpOnlySp() {
      padding-bottom: calc(300px / 2);
    }
  }
  &_container {
    text-align: left;
  }
  &_logo {
    width: 100%;
    max-width: 600px;
  }
  &_body {
    margin-top: 116px;
    color: $white;
  }
  &_title {
    @include bpOnlyPc() {
      font-size: 40px;
    }
    @include bpOnlySp() {
      font-size: 30px;
    }
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 0.1em;
  }
  &_paragraph {
    @include bpOnlyPc() {
      font-size: 20px;
      margin-top: 56px;
    }
    @include bpOnlySp() {
      font-size: 18px;
      margin-top: 36px;
    }
    font-weight: bold;
    line-height: 2.4;
    letter-spacing: 0.065em;
  }
  &_bg {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    object-fit: fill;
    background-color: #090831;
  }
}
</style>
